import { render, staticRenderFns } from "./DetalleIngresoDisminuir.vue?vue&type=template&id=23d12ed7"
import script from "./DetalleIngresoDisminuir.vue?vue&type=script&lang=js"
export * from "./DetalleIngresoDisminuir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d12ed7')) {
      api.createRecord('23d12ed7', component.options)
    } else {
      api.reload('23d12ed7', component.options)
    }
    module.hot.accept("./DetalleIngresoDisminuir.vue?vue&type=template&id=23d12ed7", function () {
      api.rerender('23d12ed7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleIngresoDisminuir.vue"
export default component.exports